import { fetchSameOrigin } from "../../Utils";


const disassociateProvider = (url) => {
  return fetchSameOrigin(url, 'DELETE', { })
    .then(_ => new Promise(resolve => {
      window.location.reload();
      resolve();
    }));
};

export default disassociateProvider;
